<div class="d-flex align-items-center justify-content-between">
  <h4 class="title ms-2">{{ 'fee.title' | translate }}</h4>
</div>
<div class="fee-container">
  <div class="fee-grid">

    @for (industry of industries; track industry.nameKey; let i = $index) {
      <div class="fee-card" [class.selected]="selectedIndex === i" (click)="selectCard(i)">
        <div class="card-icon-box">
          <img [src]="industry.icon" [alt]="industry.nameKey | translate" class="card-icon">
        </div>
        <h3 class="card-title">{{ industry.nameKey | translate }}</h3>
        <p class="card-description">{{ industry.descriptionKey | translate }}</p>

        @if (selectedIndex === i) {
          <div class="card-inputs" (click)="$event.stopPropagation()">
            <label class="upload-circle" [for]="'imageUpload-' + i">
              @if (imagePreviewUrl) {
                <img [src]="imagePreviewUrl" alt="preview" class="upload-circle-preview">
              } @else {
                <img src="assets/fee-icons/Placeholder.svg" alt="upload" class="upload-placeholder-icon">
              }
              <input [id]="'imageUpload-' + i" type="file" accept=".jpg,.jpeg,.heic,.png" class="image-input" (change)="onImageSelected($event)">
            </label>
            <div class="group-name-wrapper">
              <input type="text" class="group-name-input" [placeholder]="'fee.group_name' | translate" [(ngModel)]="groupName">
            </div>
          </div>
        }
      </div>
    }

  </div>

  <div class="fee-buttons">
    <button class="filled-white-button short-button" [disabled]="selectedIndex === null" (click)="cancel()">{{ 'cancel' | translate }}</button>
    <button class="filled-button short-button" [disabled]="selectedIndex === null" (click)="save()">{{ 'save' | translate }}</button>
  </div>
</div>
